import SearchEmpty from "@/assets/icons/search-empty.png";
import Image from "next/image";

export const ExpiredBanner = ({ text }: { text: string }) => {
  return (
    <div
      style={{
        width: "100%",
        color: "#C2C4CC",
        fontSize: "14px",
        display: "flex",
        alignItems: "center",
        marginTop: "40px",
        justifyContent: "center",
      }}
    >
      <Image src={SearchEmpty} alt="search empty" style={{ width: "50px", height: "50px" }} />
      {text}
    </div>
  );
};
